<!-- 学校活跃度排行榜 -->
<template>
  <div class="school-activity-rank">
    <!-- <div class="school-activity-rank-line"></div> -->
    <div class="school-activity-rank-title">
      <div class="name">学校活跃度排行榜</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="school-activity-rank-list">
      <div class="rank-list">
        <div class="school-activity-rank-li" v-for="item,index in rankList" :key="item.id">
          <div class="school-activity-rank-no">No.{{ index+1 }}</div>
          <div class="school-name" :title="item.name">{{ item.name }}</div>
          <div class="school-activity-progress">
            <el-progress :percentage="item.progress" :stroke-width="14" :show-text="false"></el-progress>
          </div>
          <div class="school-activity-number">{{ item.number }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getPlatformSchoolStatAPI} from "@/service/api.js"
export default {
  name: 'school-activity-ranking',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    regionType:{
      type:String,
      default:''
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    }
  },
  data() {
      return {
        rankList:[],
      }
  },
  watch:{
    startTime(){
      this.getPlatformSchoolStat()
    },
    endTime(){
      this.getPlatformSchoolStat()
    },
    address(){
      this.getPlatformSchoolStat()
    }
  },
  methods: {
    /**
     * @name 获取平台学校活跃度数据
     */
    getPlatformSchoolStat(){
      let params = {
        regionId:this.regionId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        keyWord:"",
        page:1,
        limit:15,
        sort:'visitTeaNum',
        regionType:this.regionType
      }
      getPlatformSchoolStatAPI(params).then((res)=>{
        this.rankList = []
        let maxVisitTeaNum = res.rows[0].visitTeaNum
        this.rankList = res.rows.map((item)=>{
          return {
            number:item.visitTeaNum,
            name:item.schoolName,
            progress:(item.visitTeaNum/maxVisitTeaNum).toFixed(2)*100,
            id:item.schoolId
          }
        })
      }).catch((err)=>{})
    },
  },
  mounted(){
    //获取平台学校活跃度数据
    this.getPlatformSchoolStat();
  },
}
</script>

<style lang="scss" scoped>
.school-activity-rank{
  width:100%;
  height:260px;
  position: relative;
  margin-top: 20px;
  .school-activity-rank-line{
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #209CFF, transparent);
    background-color: rgba(0, 0, 0, 0);
    margin-bottom: 5px;
  }
  .school-activity-rank-title{
    // color: #fff;
    // font-size: 18px;
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 0 13px 0 18px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .school-activity-rank-list{
    width: 100%;
    height: 200px;
    overflow-y: hidden;
    margin-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    .rank-list{
      animation: infinitevertical 15s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
    .school-activity-rank-li{
      display: flex;
      align-items: center;
      padding: 14px 0;
      .school-activity-rank-no{
        width: 35px;
        margin-right:10px;
        text-align: left;
        font-size: 14px;
        font-family: DingTalk JinBuTi;
        font-weight: 400;
        color: #FF723B;
      }
      .school-name{
        width: 130px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
      .school-activity-progress{
        width: 170px;
        text-align: left;
      }
      .school-activity-number{
        margin-left: 7px;
        // color: #fff;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #5B90E6;
      }
    }
  }
}
/* 无限滚动垂直 */
@keyframes infinitevertical {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-75%);
  }
}
</style>
<style lang="scss">
.school-activity-rank-list{
  .school-activity-rank-li{
    .school-activity-progress{
      .el-progress{
        .el-progress-bar{
          .el-progress-bar__outer{
            border-radius: 2px;
            .el-progress-bar__inner{
              border-radius: 2px;
              background: linear-gradient(90deg, #209CFF 0%, #68E0CF 100%);
            }
          }
        }
      }
    }
  }
}
</style>